import {
  addSlidesTabIndex
} from '@gravity-global/helpers/swiper/add-slides-tab-index';

const dynamicSliderInit = () => {
  const mainPattern = document.querySelectorAll('.gg-speakers-list');

  mainPattern.forEach((module) => {
    const swipers = module.querySelector('.posts-result');
    const swiperWrapper = module.querySelector('.gravity-block-dynamic-boxes--grid-view');
    const groupButton = module.querySelector('.gg-button-carousel__button-no-outline');
    if (swipers == null) {
      groupButton.classList.add('d-none');
    }
    if (!swipers || !swiperWrapper) {
      return;
    }

    const swiperSlides = module.querySelectorAll('.gravity-block-dynamic-boxes__box');
    const swiperNext = module.querySelector('.gg-button-carousel__button-no-outline__next-btn > a');
    const swiperPrev = module.querySelector('.gg-button-carousel__button-no-outline__prev-btn > a');
    const numberOfSlides = swiperSlides.length;

    if (swiperPrev) swiperPrev.setAttribute('rel', 'prev');
    if (swiperNext) swiperNext.setAttribute('rel', 'next');
    swipers.classList.add('swiper-container');
    swiperWrapper.classList.add('swiper-wrapper');
    swiperSlides.forEach((slide, index) => {
      slide.classList.add('swiper-slide', 'fade-in-up', `delay-${index}`);
    });

    const carousel = new window.Swiper(swipers, {
      centeredSlides: false,
      watchOverflow: true,
      watchSlidesProgress: true,
      slidesPerGroup: 1,
      loop: false,
      slidesPerView: 'auto',
      allowTouchMove: true,
      touchEventsTarget: "container" | "wrapper",
      navigation: {
        prevEl: swiperPrev,
        nextEl: swiperNext,
      },
      breakpoints: {
        1025: {
          slidesPerView: 3.17,
          spaceBetween: 32,
        },
        750: {
          slidesPerView: 1.97,
          spaceBetween: 24,
        },
        480: {
          slidesPerView: 1.5,
          spaceBetween: 22,
        },
        200: {
          slidesPerView: 1.1,
          spaceBetween: 22,
        },
      },
      on: {
        init: (swiper) => {
          addSlidesTabIndex(swiper);
          const slidesPerView = swiper.params.slidesPerView;
          const currentBreakpoint = swiper.currentBreakpoint;
          const currentSlidesPerView = swiper.params.breakpoints[currentBreakpoint]?.slidesPerView || slidesPerView;
          if (numberOfSlides <= currentSlidesPerView) {
            groupButton.classList.add('d-none');
          } else {
            groupButton.classList.remove('d-none');
          }
        },
        slideChange: (swiper) => addSlidesTabIndex(swiper),
      },
    });
    carousel.init();
    if (swiperPrev) swiperPrev.setAttribute('tabindex', '0');
  });
};
dynamicSliderInit();
